import * as React from "react";
import { Button, RadioGroup, TreeList } from "devextreme-react";
import { Column, Selection } from "devextreme-react/tree-list";
import { useCallback, useEffect, useRef, useState } from "react";
import { IZoekPrestatiesRequesst } from "../models/IZoekPrestatiesRequest";
import { IVisitatieRapportPrestatieItem, IZoekPrestatiesModel } from "../models/IZoekPrestatiesResponse";
import { IOperationeleDoelstelling } from "../models/OperationeleDoelstelling";
import PrestatiesDoelstellingItem from "../components/PrestatiesDoelstellingItem";
import useContstanten from "../Constanten";
import { useFetchData, useListSource } from "../components/hooks/DataSource";
import { IApiUrls } from "../models/IApiUrls";
import { IListsModel } from "../models/IHomeModel";
import { IPageLoading } from "../App";
import useLocationState from "../components/hooks/LocationState";


interface IProps extends IPageLoading {
    apiUrls: IApiUrls
    lists: IListsModel
}

interface IFormData {
    activiteit: number;
    visitatieronde: number;
    operationeleDoelstellingen: number[];
}

interface ILocationState {
    formData: IFormData;
    search?: boolean;
}

const ZoekShmPrestaties = ({ apiUrls, lists, setPageLoading }: IProps) => {

    const resultsRef = useRef<HTMLDivElement>(null);
    const { activiteiten, visitatieronden } = useContstanten();
    const dsOpDoel = useListSource(lists.doelstellingen);
    const [{ formData, search }, setFormData] = useLocationState<ILocationState>({ formData: { activiteit: 0, visitatieronde: 1, operationeleDoelstellingen: [] } })
    const [data, setData] = useState<IZoekPrestatiesModel[]>([]);
    const fetcher = useFetchData();
    const [scrollEnabled, setScrollEnabled] = useState(false);

    const groupData = (items: IVisitatieRapportPrestatieItem[]): IZoekPrestatiesModel[] => {
        return items.map(p => p.operationeleDoelstelling)
            .filter((value, index, self) => self.indexOf(value) === index)
            .map(p => ({ operationeleDoelstelling: p, visitatierapporten: items.filter(vr => vr.operationeleDoelstelling === p) }))        
    }

    useEffect(() => {
        if (search) {
            setPageLoading(true);
            fetcher(apiUrls.zoekPrestaties, formData, "POST").then((data: IVisitatieRapportPrestatieItem[]) => {
                console.log("response", data);
                setData(groupData(data));
                setPageLoading(false);
                scrollEnabled && resultsRef.current?.scrollIntoView({ behavior: "smooth" });
            }).catch(() => setPageLoading(false))
        }
    }, [search, apiUrls.zoekPrestaties, formData, fetcher, setPageLoading, scrollEnabled])
    
    const btnSearchHandler = useCallback(() => {
        setScrollEnabled(true);
        setFormData(prev => ({ ...prev, search: true }))
    }, [setFormData])

    const activiteitChangeHandler = useCallback((activiteit: number) => setFormData(prev => ({ search: false, formData: { ...prev.formData, activiteit } })), [setFormData])
    const visitatierondeChangeHandler = useCallback((visitatieronde: number) => setFormData(prev => ({ search: false, formData: { ...prev.formData, visitatieronde } })), [setFormData])
    const doelstellingenChangeHandler = useCallback((operationeleDoelstellingen: number[]) => setFormData(prev => ({ search: false, formData: { ...prev.formData, operationeleDoelstellingen } })), [setFormData])

    return <>

        <h2>Welke SHM levert goede of uitstekende prestaties?</h2>

        <div className="form-group">
            <label>Activiteit</label>
            <RadioGroup items={activiteiten} valueExpr="id" onValueChange={activiteitChangeHandler} value={formData.activiteit} />
        </div>

        <div className="form-group">
            <label>Operationele doelstellingen</label>
            <TreeList<IOperationeleDoelstelling, number>
                dataSource={dsOpDoel}
                parentIdExpr="hoofdDoelstellingId"
                rootValue={undefined}
                onSelectedRowKeysChange={doelstellingenChangeHandler}
                selectedRowKeys={formData.operationeleDoelstellingen}
                showColumnHeaders={false}
                autoExpandAll
            
            >
                <Selection mode="multiple" recursive />
                <Column dataField="naam" />
            </TreeList>
        </div>

        <div className="form-group">
            <label>Visitatieronde</label>
            <RadioGroup items={visitatieronden} valueExpr="id" onValueChange={visitatierondeChangeHandler} value={formData.visitatieronde} />
        </div>
        <div className="form-group">
            <Button text="Zoeken" type="default" icon="search" onClick={btnSearchHandler} />
        </div>
        <div id="results" ref={resultsRef}>
            {search && <h2>Resultaten:</h2>}
            {search && data.length === 0 && <p>Geen resultaten.</p>}
            {data.map((p, idx) => <div key={idx}  >
                <PrestatiesDoelstellingItem item={p} />
            </div>)}
        </div>
    </>
}
export default ZoekShmPrestaties;